"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InputText_1 = require("./InputText");
exports.InputText = InputText_1.InputText;



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/FormExample/InputText/index.ts
// module id = 237
// module chunks = 0